import { render, staticRenderFns } from "./AgreagarRegistros.vue?vue&type=template&id=593cc31c&scoped=true"
import script from "./AgreagarRegistros.vue?vue&type=script&lang=ts"
export * from "./AgreagarRegistros.vue?vue&type=script&lang=ts"
import style0 from "./AgreagarRegistros.vue?vue&type=style&index=0&id=593cc31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593cc31c",
  null
  
)

export default component.exports